export default __webpack_public_path__ + "static/media/add.af2566e7.svg";